import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcComparisonWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderComparison();
}
